import {
  normalizeHeaderTemplateCode,
  resolveHeroSettingsKey,
  type HeaderTemplateCode,
} from './templateCodes';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Primary color from published Personalizar settings, or null when unavailable. */
export function resolveBrandColorFromSettings(
  settings: Record<string, unknown> | null | undefined,
): string | null {
  if (!isRecord(settings)) {
    return null;
  }

  const templateCode = normalizeHeaderTemplateCode(
    typeof settings.templateCode === 'string' ? settings.templateCode : null,
  );

  const rawHeader = isRecord(settings.header) ? settings.header : {};
  if (typeof rawHeader.brandColor === 'string' && rawHeader.brandColor) {
    return rawHeader.brandColor;
  }

  const heroRoot = isRecord(settings.hero) ? settings.hero : null;
  if (heroRoot) {
    const heroKey = resolveHeroSettingsKey(templateCode);
    const heroConfig = isRecord(heroRoot[heroKey]) ? heroRoot[heroKey] : null;
    if (heroConfig && typeof heroConfig.brandColor === 'string' && heroConfig.brandColor) {
      return heroConfig.brandColor;
    }
  }

  if (typeof settings.brandColor === 'string' && settings.brandColor) {
    return settings.brandColor;
  }

  return null;
}
